import { put, select, takeLatest } from 'redux-saga/effects';
import { setProgramMetadataQueryStart } from "../actions/ProgramMetadataAction";
import {
    DEFINED_PRODUCT_UPDATE,
    getUpdateQueryProductSuccessAction,
    QueryProductUpdateAction,
    SELECTED_PRODUCT_UPDATE,
} from "src/actions/QueryProductUpdateAction";
import { setProgramFeesQueryStart } from "src/actions/ProgramFeesQueryAction";
import { defaultPrograms, isLoginMode } from "src/config/Config";
import { setNewProgramFeesQueryStart } from "src/actions/NewProgramFeesQueryAction";
import { UpdateQueryProductResponse } from "src/model/QueryProduct";
import { setRecommendationQueryStart } from "src/actions/RecommendationQueryAction";
import GetUserPreferenceResponse from "src/model/UserPreference";
import RequestStatus from "src/model/RequestStatus";
import ApplicationState from "src/model/ApplicationState";

export const getUserPreference = (state: ApplicationState) => state.userPreferenceRes;
export function* updateQueryProductData(action: QueryProductUpdateAction) {
    try {
        const userPreferenceResponse: GetUserPreferenceResponse = yield select(getUserPreference);
        const recommendationEnabled: boolean = userPreferenceResponse && userPreferenceResponse.requestStatus === RequestStatus.SUCCESS
            && userPreferenceResponse.data.recommendationEnabled;
        const response: UpdateQueryProductResponse = {
            countryCode: action.countryCode,
            queryProduct: action.queryProduct
        };
        yield put(getUpdateQueryProductSuccessAction(response));
        yield put(setProgramMetadataQueryStart(action.countryCode, action.queryProduct.asin));
        if (!action.queryProduct.isNewDefined) {
            if (isLoginMode() && recommendationEnabled) {
                yield put(setRecommendationQueryStart(action.countryCode, action.queryProduct.asin));
            }
            yield put(setProgramFeesQueryStart(action.countryCode, action.queryProduct, defaultPrograms));
        } else {
            yield put(setNewProgramFeesQueryStart(action.countryCode, action.queryProduct, defaultPrograms));
        }
    } catch (error) {
        console.error("UpdateQueryProductData error" + error)
        return;
    }

}

export default function* queryProductData() {
    yield takeLatest([DEFINED_PRODUCT_UPDATE, SELECTED_PRODUCT_UPDATE], updateQueryProductData);
}
